import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEEFACE,
  DELETE_EMPLOYEEFACE,
  UPDATE_EMPLOYEEFACE,
  ADD_NEW_EMPLOYEEFACE,
} from "./actionType";

import {
  getEmployeeFaceSuccess,
  getEmployeeFaceFail,
  deleteEmployeeFaceSuccess,
  deleteEmployeeFaceFail,
  updateEmployeeFaceSuccess,
  updateEmployeeFaceFail,
  addEmployeeFaceSuccess,
  addEmployeeFaceFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeFaceApi,
  getEmployeeFaceApi,
  updateEmployeeFaceApi,
  deleteEmployeeFaceApi,
  addNewEmployeeFaceApi
} from "../../helpers/backend_helper";

function* getEmployeeFace({ payload: employeeFace }) {
  try {
    const response = yield call(getEmployeeFaceApi, employeeFace);
    yield put(getEmployeeFaceSuccess(GET_EMPLOYEEFACE, response.data));
  } catch (error) {
    yield put(getEmployeeFaceFail(GET_EMPLOYEEFACE, error));
  }
}

function* onUpdateEmployeeFace({ payload: employeeFace }) {
  try {
    if (employeeFace.setApprove) {
      const response = yield call(approveEmployeeFaceApi, employeeFace);
      yield put(updateEmployeeFaceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeFaceApi, employeeFace);
      yield put(updateEmployeeFaceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeFaceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeFace({ payload: employeeFace }) {
  try {
    const response = yield call(deleteEmployeeFaceApi, employeeFace);
    yield put(deleteEmployeeFaceSuccess({ employeeFace, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeFaceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeFace({ payload: employeeFace }) {
  try {
    const response = yield call(addNewEmployeeFaceApi, employeeFace);
    yield put(addEmployeeFaceSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeFaceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeFace() {
  yield takeEvery(GET_EMPLOYEEFACE, getEmployeeFace);
}

export function* watchUpdateEmployeeFace() {
  yield takeEvery(UPDATE_EMPLOYEEFACE, onUpdateEmployeeFace);
}

export function* watchDeleteEmployeeFace() {
  yield takeEvery(DELETE_EMPLOYEEFACE, onDeleteEmployeeFace);
}

export function* watchAddNewEmployeeFace() {
  yield takeEvery(ADD_NEW_EMPLOYEEFACE, onAddNewEmployeeFace);
}

function* employeeFaceSaga() {
  yield all([
    fork(watchGetEmployeeFace),
    fork(watchDeleteEmployeeFace),
    fork(watchUpdateEmployeeFace),
    fork(watchAddNewEmployeeFace)
  ]);
}

export default employeeFaceSaga;
